import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CustomBreakpointsGrid from './CustomBreakpointsGrid';
import ClientProvider from './client';
export default createDemo(import.meta.url, CustomBreakpointsGrid, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/components/grid/demos/custom-breakpoints/CustomBreakpointsGrid.js",
    "fileName": "CustomBreakpointsGrid.js",
    "language": "javascript",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { ThemeProvider, createTheme } from '@mui/system';\nimport Box from '@mui/system/Box';\nimport Grid from '@mui/system/Grid';\nimport styled from '@mui/system/styled';\n\nconst Item = styled('div')(({ theme }) => ({\n  backgroundColor: '#fff',\n  border: '1px solid',\n  borderColor: '#ced7e0',\n  padding: theme.spacing(1),\n  borderRadius: '4px',\n  textAlign: 'center',\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n    borderColor: '#444d58',\n  }),\n}));\n\nexport default function CustomBreakpointsGrid() {\n  return (\n    <ThemeProvider\n      theme={createTheme({\n        breakpoints: {\n          values: {\n            laptop: 1024,\n            tablet: 640,\n            mobile: 0,\n            desktop: 1280,\n          },\n        },\n      })}\n    >\n      <Box sx={{ flexGrow: 1 }}>\n        <Grid container spacing={{ mobile: 1, tablet: 2, laptop: 3 }}>\n          {Array.from(Array(4)).map((_, index) => (\n            <Grid\n              key={index}\n              size={{\n                mobile: 6,\n                tablet: 4,\n                laptop: 3,\n              }}\n            >\n              <Item>{index + 1}</Item>\n            </Grid>\n          ))}\n        </Grid>\n      </Box>\n    </ThemeProvider>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 51,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { ThemeProvider, createTheme } from '@mui/system';\nimport Box from '@mui/system/Box';\nimport Grid from '@mui/system/Grid';\nimport styled from '@mui/system/styled';\n\nconst Item = styled('div')(({ theme }) => ({\n  backgroundColor: '#fff',\n  border: '1px solid',\n  borderColor: '#ced7e0',\n  padding: theme.spacing(1),\n  borderRadius: '4px',\n  textAlign: 'center',\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n    borderColor: '#444d58',\n  }),\n}));\n\nexport default function CustomBreakpointsGrid() {\n  return (\n    <ThemeProvider\n      theme={createTheme({\n        breakpoints: {\n          values: {\n            laptop: 1024,\n            tablet: 640,\n            mobile: 0,\n            desktop: 1280,\n          },\n        },\n      })}\n    >\n      <Box sx={{ flexGrow: 1 }}>\n        <Grid container spacing={{ mobile: 1, tablet: 2, laptop: 3 }}>\n          {Array.from(Array(4)).map((_, index) => (\n            <Grid\n              key={index}\n              size={{\n                mobile: 6,\n                tablet: 4,\n                laptop: 3,\n              }}\n            >\n              <Item>{index + 1}</Item>\n            </Grid>\n          ))}\n        </Grid>\n      </Box>\n    </ThemeProvider>\n  );\n}\n"
      ]
    ],
    "totalLines": 51,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/system",
      "@mui/system/Box",
      "@mui/system/Grid",
      "@mui/system/styled"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
